import {
    changeSubprojectSelected,
    fetchActivities,
    fetchActivitiesDetail,
    fetchConfigurationProcessWeek,
    fetchDataProjectSite,
    fetchFiltersDashboard,
    fetchProcessWeek,
    fetchSchemaProjectSite,
    fetchSubProcessFilter,
    fetchSubProcessWeek,
    fetchSubprojects,
    setFilteredYear,
    setFiltersDashboard,
    setSubProcessFiltersDashboardDetail,
} from './actions';

const actionsToExport = {
    changeSubprojectSelected,
    fetchSubprojects,
    fetchActivities,
    fetchActivitiesDetail,
    setFilteredYear,
    fetchProcessWeek,
    fetchSubProcessWeek,
    fetchConfigurationProcessWeek,
    fetchFiltersDashboard,
    setFiltersDashboard,
    fetchSchemaProjectSite,
    fetchDataProjectSite,
    fetchSubProcessFilter,
    setSubProcessFiltersDashboardDetail,
};
export default actionsToExport;
